export const PRODUCT_RESULTS = ['flow', 'wrapped', 'as_is'] as const

export type ProductResult = (typeof PRODUCT_RESULTS)[number]

export const PRODUCT_RESULT_LABELS: Record<ProductResult, string> = {
  flow: 'Flow',
  wrapped: 'Equity OTC',
  as_is: 'As-Is',
}

export const PRODUCT_RESULT_OPTIONS = PRODUCT_RESULTS.map((p) => ({
  label: PRODUCT_RESULT_LABELS[p],
  value: p,
}))
